import { TextLink } from '@oneaudi/unified-web-alpha-components';
import { useCallback, useState } from 'react';
import { CompareLinkStyle } from '~/app/compositions/sidebar/trim-line/components/trim-line-compare';
import { useI18n } from '~/app/i18n/i18n';
import { CompareLayerWrapper } from '~/app/pages/configurator/components/compare-layer-wrapper';
import { appTrackingService } from '~/app/tracking/app-tracking-service';
import { EventAction, LayerType } from '~/app/tracking/feld-m-types';
import { Dialog } from '~/components/dialog';

export const DriveTrainCompare = () => {
	const { i18n } = useI18n();

	const [isOpen, setIsOpen] = useState<boolean>(false);

	const onOpenChange = useCallback(
		(open: boolean) => {
			setIsOpen(open);
			appTrackingService.trackSelectionClickEvent({
				eventAction: EventAction.InternalLink,
				eventName: `click to ${open ? 'open' : 'close'} ${LayerType.EngineAndTrimComparisonLayer}`,
				label: i18n('ngc.dialogs.comparison.driveTrain.trigger'),
				elementName: 'text link',
			});

			appTrackingService.updateLayerComponent(LayerType.EngineAndTrimComparisonLayer, open ? 'open' : 'close');

			appTrackingService.viewChangeEvent({
				eventName: open ? `configurator - ${LayerType.EngineAndTrimComparisonLayer}` : 'generic',
				componentName: open ? `${LayerType.EngineAndTrimComparisonLayer.split(' ').join('-')}` : '',
			});
		},
		[i18n],
	);

	return (
		<CompareLinkStyle>
			<Dialog
				classNameDialog="drive-train-compare-dialog"
				triggerElement={
					<TextLink variant={'standalone'} size={'sm'} onClick={() => onOpenChange(true)}>
						{i18n('ngc.dialogs.comparison.driveTrain.trigger')}
					</TextLink>
				}
				onCloseButtonClick={() => onOpenChange(false)}
				open={isOpen}>
				{isOpen && (
					<CompareLayerWrapper
						key="drive-train-compare"
						setIsOpen={onOpenChange}
						open={isOpen}
						config={{
							selectedTab: 'technicalData',
							isCompareActive: true,
						}}
					/>
				)}
			</Dialog>
		</CompareLinkStyle>
	);
};
